import BrazilianResidentIDTooltip from './custom-tooltips/BrazilianResidentIDTooltip';
import ChineseResidentIDTooltip from './custom-tooltips/ChineseResidentIDTooltip';
import CV2Tooltip from './custom-tooltips/CV2Tooltip';
import ResidentIdTooltip from './custom-tooltips/ResidentIdTooltip';
import PayerNameTooltip from './custom-tooltips/PayerNameTooltip';

export const TooltipAndOverlayIDs = {
  ADYEN_V2_ACTION: 'ADYEN_V2_ACTION',
  AFTERPAY: 'AFTERPAY',
  AFTERPAY_CLEARPAY: 'AFTERPAY_CLEARPAY',
  BRAZILIAN_RESIDENT_ID: 'BRAZILIAN_RESIDENT_ID',
  CHINESE_RESIDENT_ID: 'CHINESE_RESIDENT_ID',
  CLEARPAY: 'CLEARPAY',
  CONTACT_NUMBER_INFO: 'CONTACT_NUMBER_INFO',
  CV2_TOOLTIP: 'CV2_TOOLTIP',
  DELETE_ADDRESS: 'DELETE_ADDRESS',
  DELIVERY_INFORMATION: 'DELIVERY_INFORMATION',
  EDIT_ADDRESS: 'EDIT_ADDRESS',
  EDIT_DELETE_ADDRESS: 'EDIT_DELETE_ADDRESS',
  EDIT_DELETE_ADDRESS_SUCCESS: 'EDIT_DELETE_ADDRESS_SUCCESS',
  EDIT_DELIVERY_ADDRESS: 'EDIT_DELIVERY_ADDRESS',
  IMPORT_TAX: 'IMPORT_TAX',
  SUBSCRIPTION: 'SUBSCRIPTION',
  KLARNA: 'KLARNA',
  KOREAN_PASSPORT_NUMBER: 'KOREAN_PASSPORT_NUMBER',
  KOREAN_PCC_NUMBER: 'KOREAN_PCC_NUMBER',
  MODE: 'MODE',
  OPENPAY: 'OPENPAY',
  ORDERSUMMARY: 'ORDER_SUMMARY_OVERLAY',
  PAYER_NAME: 'PAYER_NAME',
  PAYVYNE: 'PAYVYNE',
  POSTAL_ID_INFO: 'POSTAL_ID_INFO',
  RESIDENT_ID_DELIVERY_DESCRIPTION: 'RESIDENT_ID_DELIVERY_DESCRIPTION',
  SEZZLE: 'SEZZLE',
  SPLITIT: 'SPLITIT',
  SPOTII: 'SPOTII',
  THREE_D_SECURE: 'THREE_D_SECURE',
  TRUSTLY: 'TRUSTLY',
  ZIPPAY: 'ZIPPAY',
  COLLECTION: 'COLLECTION',
  REMOVE_GIFTCARD: 'REMOVE_GIFTCARD',
  FRASERS_PLUS: 'FRASERS_PLUS',
};

export function getTooltip(tooltipID) {
  const tooltips = {
    [TooltipAndOverlayIDs.CV2_TOOLTIP]: <CV2Tooltip tooltipID={tooltipID} />,
    [TooltipAndOverlayIDs.CHINESE_RESIDENT_ID]: <ChineseResidentIDTooltip tooltipID={tooltipID} />,
    [TooltipAndOverlayIDs.BRAZILIAN_RESIDENT_ID]: <BrazilianResidentIDTooltip tooltipID={tooltipID} />,
    [TooltipAndOverlayIDs.KOREAN_PASSPORT_NUMBER]: <ResidentIdTooltip tooltipID={tooltipID} />,
    [TooltipAndOverlayIDs.PAYER_NAME]: <PayerNameTooltip tooltipID={tooltipID} />,
  };

  return tooltips[tooltipID];
}
